<script setup lang="ts">
import TheSidebar from '@/components/TheSidebar.vue';
import TheNavbar from '@/components/TheNavbar.vue';
import { FdxDrawer } from '@foodics/ui-common';
import { computed, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useViewport } from '@/composables/viewport';
import { useAuth } from '@/composables/auth';
import { useFeatureFlags } from '@/composables/featureFlags';

const isSidebarDrawerOpened = ref(false);

const { isTabletOrSmaller } = useViewport();

const { isAuthenticated } = useAuth();

const showSidebarDrawer = computed(() => {
    return isTabletOrSmaller.value;
});

const router = useRouter();
router.beforeEach(() => {
    isSidebarDrawerOpened.value = false;
});

watch(isAuthenticated, () => {
    if (!isAuthenticated.value) {
        router.push('/login');
    }
});

// to be available in all authenticated routes
useFeatureFlags();
</script>

<template>
    <div
        class="grid grid-cols-[0px_1fr] lg:grid-cols-[210px_1fr] xl:grid-cols-[248px_1fr] transition-[grid-template-columns] duration-300 h-screen max-h-screen"
    >
        <div class="bg-gray-100">
            <Transition name="fade">
                <TheSidebar v-if="!showSidebarDrawer" />
            </Transition>
        </div>

        <div class="grid grid-rows-[auto_1fr] max-h-full overflow-auto">
            <TheNavbar @open-sidebar-drawer="isSidebarDrawerOpened = true" />

            <main class="bg-white overflow-auto">
                <RouterView v-slot="{ Component }" v-if="isAuthenticated">
                    <Transition name="fade" mode="out-in" appear>
                        <component :is="Component" />
                    </Transition>
                </RouterView>
            </main>
        </div>

        <FdxDrawer
            v-if="showSidebarDrawer"
            v-model="isSidebarDrawerOpened"
            @closed="isSidebarDrawerOpened = false"
            placement="start"
            class="drawer-sidebar"
        >
            <TheSidebar />
        </FdxDrawer>
    </div>
</template>

<style scoped>
:deep(.drawer-sidebar > .fdx-dialog__body) {
    @apply p-0 bg-gray-100;
}

:deep(.drawer-sidebar > .fdx-dialog__header) {
    @apply hidden;
}
</style>
